import { CatalogDragListRowRect } from '../../hooks/useCatalogProductsDragAndDrop.types';

export const measureCatalogListDragRect = (
  node: HTMLElement | null,
): CatalogDragListRowRect | null => {
  if (!node) {
    return null;
  }

  const { width, height } = node.getBoundingClientRect();

  return { width, height };
};
